import React from 'react';
import { Hero } from '../components/sections/Hero';
import { WhatWeOffer } from '../components/sections/WhatWeOffer';
import { HowItWorks } from '../components/sections/HowItWorks';
import { AboutSection } from '../components/sections/AboutSection';
import { ContactSection } from '../components/sections/ContactSection';
export function Home() {
  return <>
      <Hero data-id="element-209" data-mp="2x7is2wsjaujp" />
      <WhatWeOffer data-id="element-210" data-mp="1zhxmoj37t120" />
      <HowItWorks data-id="element-211" data-mp="1ziqu7m9zzul7" />
      <AboutSection data-id="element-212" data-mp="1zj8z17aq7h4q" />
      <ContactSection data-id="element-213" data-mp="1zjs4hoj6wd1v" />
    </>;
}